
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  Label,
  ResponsiveContainer,
  Cell,
} from "recharts";

const StackedParentDomainChart = ({ domainScore }) => {
  // const dummyData = [
  //   {
  //     parentDomain: "Product",
  //     qualityScore: 0,
  //     domains: [
  //       { name: "Sample", qualityScore: 0 },
  //       { name: "Quality / R&D", qualityScore: 0 },
  //       { name: "layer Product Lifecycle", qualityScore: 0 },
  //     ],
  //   },
  //   {
  //     parentDomain: "Test Parent",
  //     qualityScore: 14.86,
  //     domains: [
  //       { name: "Test Domain 1", qualityScore: 14.86 },
  //       { name: "Test Domain 2", qualityScore: 0 },
  //     ],
  //   },
  //   {
  //     parentDomain: "One Demand",
  //     qualityScore: 84.35,
  //     domains: [
  //       { name: "Marketing", qualityScore: 0 },
  //       { name: "Sales", qualityScore: 84.35 },
  //     ],
  //   },
  //   {
  //     parentDomain: "Supply ",
  //     qualityScore: 92.23,
  //     domains: [
  //       { name: "Sourcing", qualityScore: 0 },
  //       { name: "Logistics", qualityScore: 92.23 },
  //       { name: "Manufacturing", qualityScore: 0 },
  //     ],
  //   },
  //   {
  //     parentDomain: "Finance ",
  //     qualityScore: 0,
  //     domains: [{ name: "Control & Governance", qualityScore: 0 }],
  //   },
  //   {
  //     parentDomain: "P&O",
  //     qualityScore: 0,
  //     domains: [{ name: "Associate", qualityScore: 0 }],
  //   },
  // ];

  const data = Array.isArray(domainScore) && domainScore.length ? domainScore : [];

  // const getColor = [
  //   { color: "#FB0301", label: "< 90%" },
  //   { color: "#009F52", label: "90% – 94%" },
  //   { color: "#FFC100", label: "≥ 95%" },
  // ];
    const getColor = [
    { color: "#0874BE", label: "< 90%" },
    { color: "#9897FF", label: "90% – 94%" },
    { color: "#80C6AD", label: "≥ 95%" },
  ];

  const getColorByScore = (score) => {
    if (score < 90) return getColor[0].color;
    if (score < 95) return getColor[1].color;
    return getColor[2].color;
  };

  const chartData = data.map((parent) => {
    const obj = { parentDomain: parent.parentDomain.trim() };
    parent.domains.forEach((domain) => {
      obj[domain.name.trim()] = domain.qualityScore;
    });
    return obj;
  });

 const allDomainNames = [
  ...new Set(data.flatMap((p) => (p.domains || []).map((d) => d.name.trim()))),
];

  return (
    <div style={{ width: "100%", height: 420 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 5, left: 5, bottom: 14 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
     <XAxis
  dataKey="parentDomain"
  tick={{
    fontSize: 10,
    fill: '#373d3f',
    textAnchor: 'middle',
  }}
>
  <Label
    value="Domain"
    offset={-10}
    position="insideBottom"
    style={{
      fontSize: "15px",
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
fill: '#373d3f',    }}
  />
</XAxis>

      <YAxis tick={{ fontSize: 12 ,fill:'#373d3f'}}>
  <Label
    value="Quality Score"
    angle={-90}
    position="insideLeft"
    style={{
      fontSize: "15px",
      fontWeight: 600,
      fontFamily: "Poppins, sans-serif",
fill: '#373d3f',    
    }}
  />
</YAxis>

<Tooltip
  contentStyle={{
    backgroundColor: "white",
   
  }}
  formatter={(value, name) => [`${value}`, `${name}`]} 
  labelFormatter={() => ""} 
/>
          {allDomainNames.map((domain, i) => (
            <Bar key={domain} dataKey={domain} stackId="a" isAnimationActive={false} 
   activeBar={{ fillOpacity: 1 }}
>
              {i === allDomainNames.length - 1 && (
                <LabelList
                  dataKey={() => ""}
                  content={({ x, width, y, index }) => (
                    <text
                      x={x + width / 2}
                      y={y - 5}
                      textAnchor="middle"
                      fill="#000"
                      fontSize={12}
                    >
{data[index] ? data[index].qualityScore : ""}          
          </text>
                  )}
                />
              )}

              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={getColorByScore(entry[domain])}
                />
              ))}
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedParentDomainChart;
